import { createTheme } from "@material-ui/core/styles";

export const themeOptions = createTheme ({
    palette: {
        primary: {
            main: '#FCB01F',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#E3A01B',
        },
    },
});